/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CameraEventCode = {
    Junction: 'Junction',
    In: 'In',
    Out: 'Out'
} as const;
export type CameraEventCode = typeof CameraEventCode[keyof typeof CameraEventCode];

